module.exports = {
  notIssued: '未签发',
  getBack: '已取回',
  receive: '已接收',
  toClaim: '已认领',
  issuance: '已签发',
  changeSingle: '改单中',
  lineCreditDialog: {
    title: '提示信息',
    businessNumber: '该业务编号：',
    mblNo: 'MBL NO：',
    hblNo: 'HBL NO：',
    partners: '合作伙伴：',
    lines: '信用额度：已超出，{0}元',
    paymentDays: '信用账期：{0}',
    unableSave: '无法使用“客户自出单”，请及时付款。',
    cantUse: '当前无法保存客户自出单 字段勾选项。',
    triggerRemind: '已触发系统提醒，请及时付款。',
    through: '放单规则审核通过',
    continueOrders: '确认是否继续放单？',
    confirm: '确认',
    cancel: '关闭'
  }
}
